import { render, staticRenderFns } from "./FaqsCategoryIndex.vue?vue&type=template&id=6bd61e41&lang=pug"
import script from "./FaqsCategoryIndex.vue?vue&type=script&lang=js"
export * from "./FaqsCategoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports